// extracted by mini-css-extract-plugin
export default {"container":"nq-z","heading":"oq-z","text":"pq-z","info":"qq-z","link":"rq-z","fullMaxWidth":"sq-z"};